import { hostsConfig } from '@openeducation/oe-it-services';
import type { Environment } from '@openeducation/oe-it-services';
import axios from 'axios';

export default abstract class RequestAssistanceDao {
  static async requestAssistance(
    env: Environment,
    classroomId: string,
    teacherId: number,
    notification: string
  ) {
    const url = hostsConfig[env].notificationServiceUrl;

    const { data } = await axios.post<void>(
      `${url}/notifications/systems/help`,
      {
        sentByPersonId: teacherId,
        classroomId,
        notification,
      }
    );

    return data;
  }
}
